import { Badge } from "@/components/ui/badge";
import { TableCell, TableRow } from "@/components/ui/table";
import { formatUsageBillingCurrency } from "./usage-billing-format";
import {
  sumUnitTotalAmounts,
  type UsageBillingOrgGroup,
} from "./usage-billing-group-utils";

type UsageBillingOrgGroupHeaderProps = {
  group: UsageBillingOrgGroup;
  columnCount: number;
};

export function UsageBillingOrgGroupHeader({
  group,
  columnCount,
}: UsageBillingOrgGroupHeaderProps) {
  const unitCount = group.units.length;
  const unitLabel = unitCount === 1 ? "unit" : "units";
  const subtotalAmount = formatUsageBillingCurrency(
    sumUnitTotalAmounts(group.units),
  );

  return (
    <TableRow className="bg-gray-50 hover:bg-gray-50">
      <TableCell colSpan={columnCount} className="py-2">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <span className="font-semibold text-gray-900">
              {group.organizationName}
            </span>
            <Badge variant="secondary" size="small">
              {unitCount} {unitLabel}
            </Badge>
          </div>
          <span className="text-sm text-gray-500 tabular-nums">
            Subtotal (loaded): {subtotalAmount}
          </span>
        </div>
      </TableCell>
    </TableRow>
  );
}
